import fetchDrbApi from './fetchDrbApi';

const fetchDrbApiEntityById = entityId =>
  fetchDrbApi({ path: '/entities/' + entityId })
    .then(res => res.json())
    .catch(err => console.error(err));

export default fetchDrbApiEntityById;
